import { Button } from "@theorgchartdev/storybook";
import { FormatPositionLabel } from "@coreapp/utils/FormatPositionLabel";
import type { QObjDBObject } from "@coreapp/CoreApp/QObjDBObject";
import type { QXDoc } from "@coreapp/CoreApp/QXDoc";
import { useNavigationContext } from "@/providers/NavigationProvider";

type Props = {
  doc: QXDoc;
  dataObj: QObjDBObject;
  setShowMoreFields?: React.Dispatch<React.SetStateAction<boolean | null>>;
};

export const BaseballCardParentReference = (props: Props) => {
  const { LaunchUIElement } = useNavigationContext();

  const handleClick = () => {
    const canvasRef = props.doc.GetCanvasRef();
    canvasRef?.ClearSelection();
    props.setShowMoreFields?.(true);

    LaunchUIElement("profile", true, { target: props.dataObj });
  };

  return (
    <Button
      className="oc-padding-left-0"
      iconProps={{ name: "arrow-left-solid" }}
      onClick={handleClick}
      modifier="tertiary"
    >
      {FormatPositionLabel(props.dataObj)}
    </Button>
  );
};
